module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.flag) ? _c('div', {
    staticClass: "main-top",
    style: ({
      height: _vm.height
    }),
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "calc(100%)",
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "pimg",
    attrs: {
      "src": require("../assets/top.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "padding": "0",
      "padding-top": "20px",
      "margin": "0",
      "font-size": "34px"
    }
  }, [_vm._v(_vm._s(_vm.monthDate)), _c('br'), _vm._v(_vm._s(_vm.hoursMinute))]), _vm._v(" "), _c('van-divider'), _vm._v(" "), _c('img', {
    attrs: {
      "width": "140px",
      "src": require("../../src/assets/main.png")
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "0",
      "margin": "0",
      "font-size": "17px",
      "font-weight": "700",
      "color": "green",
      "line-height": "30px",
      "margin-top": "5px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.result.positionName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "20px"
    }
  }, [(_vm.result.positionName !== '') ? _c('p', {
    staticStyle: {
      "padding": "0",
      "margin": "0",
      "font-size": "15px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("绿码：")]), _vm._v("该区域已按时消杀")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "special",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('van-divider'), _vm._v(" "), _c('div', {
    staticClass: "noBa"
  }, [_c('van-icon', {
    attrs: {
      "name": "passed"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "role": "marquee"
    }
  }, [_vm._v("\n                                已消杀\n                            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "footed"
  }, [_vm._v("\n                            最新消杀时间\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "footedl"
  }, [_vm._v("\n                            " + _vm._s(_vm.result.createdAt) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "fimg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/hang.png"),
      "width": "85px",
      "alt": ""
    }
  })])], 1)], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('br')]) : _c('div', {
    staticClass: "p404"
  }, [_c('img', {
    staticStyle: {
      "width": "calc(100% - 100px)"
    },
    attrs: {
      "src": require("../assets/404.svg")
    }
  }), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('div', {
    staticClass: "desc",
    attrs: {
      "data-v-206e07da": ""
    }
  }, [_vm._v("抱歉，功能还未开放，敬请期待。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e218066!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/home.vue
// module id = 399
// module chunks = 2